import React, { useContext, useState } from 'react'
import ExitIntentModal from '../../Pages/ServicesLandingPage/ExitIntentModal';
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import { t } from 'i18next';
import { LoaderContext } from '../../AuthContext/AuthContext';


const FAQ = ({ serviceData, slug, showExitIntentModal, setShowExitIntentModal }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const { selectedLanguageID } = useContext(LoaderContext);


    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    return (
        <>
            <section data-aos-duration="1000" data-aos="zoom-in" className="faq-one faq-one--page">
                <div
                    className="container"
                    style={{ display: "flex", flexDirection: "column" }}
                >
                    <div className="section-title text-center">
                        <h6
                            className="sec-title__tagline bw-split-in-right"
                            style={{
                                perspective: "400px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >

                            <img className=" tagline-img" src={pandit} alt="" /> {t("FAQ's")}

                        </h6>
                        <h3
                            className="sec-title__title bw-split-in-left"
                            style={{ perspective: "400px", textAlign: "center" }}
                        >
                            {t("Frequently Asked Questions")}.
                        </h3>
                    </div>
                    <div className="row">

                        <div className="col-xl-12">
                            <div className="faq-one__accordion careox-accordion">
                                {serviceData.FaqObj.map((faq, index) => (
                                    <div
                                        key={index}
                                        className={`accrodion ${activeIndex === index ? "active" : ""
                                            }`}
                                        style={{ "--accent-color": faq.color }}
                                    >
                                        <div
                                            className="accrodion-title"
                                            onClick={() => toggleFAQ(index)}
                                        >
                                            <h4>
                                                <span
                                                    className="accrodion-title__number"
                                                    style={{ marginRight: "10px", fontWeight: "500" }}
                                                ></span>
                                                {faq.question}
                                                <span className="accrodion-title__icon"></span>
                                            </h4>
                                        </div>
                                        <div
                                            className="accrodion-content"
                                            style={{
                                                maxHeight: activeIndex === index ? "200px" : "0",
                                                overflow: "hidden",
                                                transition: "max-height 0.5s ease-in-out",
                                            }}
                                        >
                                            <div className="inner">
                                                <p>{faq.answer}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>


                        <ExitIntentModal
                            slug={slug}
                            show={showExitIntentModal}
                            onHide={() => {
                                setShowExitIntentModal(false);
                            }}
                        />
                    </div>
                </div>
            </section>
        </>
    )
}

export default FAQ
